module.exports = __webpack_public_path__ + "img/bg-06.79fe50d7.png";